<template>
  <div id="app" class="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  mounted() {
    // if (this.utils.isMobile()) {
    //   console.log("手机端");
    //   this.$router.replace("/MobileHome");
    // } else {
    //   console.log("pc端");
    //   this.$router.replace("/Home");
    // }
  },
  methods: {},
};
</script>

<style>
body,
div,
p,
h1,
h2,
h3,
h4,
h5,
h6,
ul,
ol,
li {
  margin: 0;
  padding: 0;
}

*,
:after,
:before {
  box-sizing: border-box;
}

html,
body,
.app {
  width: 100%;
  height: 100%;
  min-width: 1200px;
  /* overflow: hidden; */
  color: #000000;
}

body {
  font-family: Source Han Sans CN;
}

ul {
  list-style: none;
}

.content {
  width: 1200px;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/App.vue